@if (showModal()) {
<app-modal (closeModal)="close()">
  <h1 modal-title>{{ buttonText }} Categoría</h1>

  <form
    [formGroup]="categoryForm"
    (submit)="submit()"
    class="flex flex-col gap-4"
    modal-content
  >
    <div class="flex flex-col gap-2">
      <label for="category-name">Nombre de la Categoría</label>
      <input
        type="text"
        id="category-name"
        formControlName="name"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="category-description">Descripción</label>
      <textarea
        id="category-description"
        formControlName="description"
        class="basic-input h-20 resize-y"
      ></textarea>
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row sm:justify-between sm:space-x-2"
    >
      <button type="button" class="secondary normal" (click)="cancel()">
        Cancelar
      </button>

      <button
        type="submit"
        class="primary normal"
        [disabled]="categoryForm.invalid"
      >
        {{ buttonText }}
      </button>
    </div>

    @if (confirmationMessage && categoryForm.pristine) {
    <span class="mt-2 text-green-700 text-sm">{{ confirmationMessage }}</span>
    } @if (errorMessage && categoryForm.pristine) {
    <span class="mt-2 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </form>
</app-modal>
}
